module.exports = __webpack_public_path__ + "img/register-v2-dark.964c099d.svg";